import React, { ReactNode, CSSProperties } from "react";
import { Box, Text } from "@mantine/core";

interface BorderFrameProps {
  label?: string;
  children: ReactNode;

  showBorder?: boolean;
}

const labelStyle: CSSProperties = {
  position: "absolute",
  fontWeight: "bold",
  //   backgroundColor: "#EDEDED", // Match the border color to blend with the border
  padding: "0 5px", // Small padding to ensure the text stands out
  color: "#666", // Dimmed text color for readability
  zIndex: 1, // Ensure the text appears above the border
};

const getLabelPositionStyle = (position: "left" | "right"): CSSProperties => {
  switch (position) {
    case "left":
      return {
        top: "53%",
        left: "17px", // Adjust to position the text over the border
        transform: "translateY(-50%) rotate(-90deg)",
        transformOrigin: "left center",
      };
    case "right":
      return {
        top: "53%",
        right: "17px", // Adjust to position the text over the border
        transform: "translateY(-50%) rotate(90deg)",
        transformOrigin: "right center",
      };
    default:
      return {};
  }
};

const BorderFrame: React.FC<BorderFrameProps> = ({
  label = "EHR Sidebar",
  children,
  showBorder = false,
}) => {
  return (
    <>
      {" "}
      <Box
        style={{
          ...(showBorder === false && {
            border: "35px solid rgb(197 197 197)",
            borderRadius: "8px",
            maxWidth: "100%",
            maxHeight: "100vh",
            overflow: "hidden",
            boxSizing: "border-box",
            padding: "1px",
            display: "flex",
            flexDirection: "column",
          }),
        }}
      >
        {!showBorder && (
          <>
            {["left", "right"].map((position) => (
              <Box
                key={position}
                style={{
                  ...labelStyle,
                  ...getLabelPositionStyle(position as "left" | "right"),
                }}
              >
                <Text c={"dimmed"}>{label}</Text>
              </Box>
            ))}
          </>
        )}

        <Box style={{ flex: 1, height: showBorder ? "100vh" : "",overflowY:"auto" }}>
          {children}
        </Box>
      </Box>
    </>
  );
};

export default BorderFrame;
